import type { BlockStateLawsMap } from 'types/block-state-laws-map';

import React from 'react';
import { Button, Wrap, Paragraph } from '@leafwell/components';
import Image from 'next/image';

import HeadingBody from './heading-body';
import StateLawsMap from './state-laws-map';

const StateLawsCard: React.FC<BlockStateLawsMap> = ({
  button,
  title,
  content,
  lawStatuses,
}) => {
  return (
    <Wrap className="md:grid-cols-2 md:gap-x-10 lg:gap-x-24 md:pb-20">
      <StateLawsMap statuses={lawStatuses} />
      <article className="grid gap-3 md:gap-6 items-start self-start">
        <Image
          src="/diamond.svg"
          className="mb-3"
          loading="lazy"
          width={39}
          height={40}
          alt="state laws star icon"
        />
        <HeadingBody
          {...{
            level: '2',
            title,
          }}
        />
        <Paragraph size="large">{content}</Paragraph>
        {button && (
          <Button
            {...{
              className: 'mt-3 justify-self-start',
              rounded: true,
              variant: 'gradient',
              href: button.url,
              label: button.title,
              target: button.target,
            }}
          />
        )}
      </article>
    </Wrap>
  );
};

export default StateLawsCard;
